<template>
  <main class="rns">
    <div class="rns__params__wrapper" v-if="!rnsFind && !loader">
      <p class="rns__params__title">Params</p>
      <div class="rns__params">
        <div class="rns__param" v-for="(param, index) in params">
          <div class="rns__param__info">
            <input :placeholder="param.name" v-model="param.value" />
            <button @click="paramAddItem(index, param.value)" :class="{ disable: !param.value }">
              Добавить
            </button>
          </div>
          <div class="rns__param__added" v-if="param.array.length">
            <span v-for="(addedItem, indexAdded) in param.array">
              {{ addedItem }}
              <img
                src="../../assets/images/close.svg"
                alt="delete"
                @click="deleteAddedItemParam(index, indexAdded)"
              />
            </span>
          </div>
        </div>
        <textarea placeholder="JSON" v-model="jsonParam" />
        <button class="rns__params__find" :class="{ disable: disabledFindBtn }" @click="findRns">
          Найти
        </button>
        <p class="errorMsg" v-if="errorMsg">Ошибка</p>
      </div>
    </div>
    <Loader v-if="loader" />
    <div class="rns__table__wrapper" v-if="rnsFind">
      <div class="rns__table__header" @click="backToFind">
        <img src="../../../src/assets/images/arrowLeft.svg" alt="arrowLeft" />
        <p>Вернуться на поиск</p>
      </div>
      <table>
        <thead>
          <tr>
            <td>Relation</td>
            <td>Params</td>
          </tr>
        </thead>
        <tbody>
          <TableRowRns v-for="(row, index) in rnsFoundInfo" :key="index" :row="row" />
        </tbody>
      </table>
    </div>
  </main>
</template>

<script>
import './rns.scss'

import Loader from '../../components/Loader/Loader'
import TableRowRns from '../../components/TableRowRns/TableRowRns'
import cookie from 'vue-cookie'

export default {
  name: 'Rns',
  components: {
    Loader,
    TableRowRns
  },
  data() {
    return {
      rnsFind: false,
      jsonParam: '',
      params: [
        {
          array: [],
          value: '',
          name: 'user_id'
        },
        {
          array: [],
          value: '',
          name: 'username'
        },
        {
          array: [],
          value: '',
          name: 'ip'
        },
        {
          array: [],
          value: '',
          name: 'wallet'
        },
        {
          array: [],
          value: '',
          name: 'roblox_username'
        },
        {
          array: [],
          value: '',
          name: 'email'
        },
        {
          array: [],
          value: '',
          name: 'payment_system_invoice'
        },
        {
          array: [],
          value: '',
          name: 'withdrawal_id'
        },
        {
          array: [],
          value: '',
          name: 'topup_id'
        }
      ],
      rnsFoundInfo: [],
      errorMsg: false,
      loader: false
    }
  },
  computed: {
    disabledFindBtn() {
      if (this.jsonParam) {
        return false
      }
      for (const param of this.params) {
        if (param.array.length) {
          return false
        }
      }
      return true
    }
  },
  methods: {
    paramAddItem(index, value) {
      this.params[index].array.push(value)
      this.params[index].value = ''
    },
    deleteAddedItemParam(indexIssuerParam, indexItem) {
      this.params[indexIssuerParam].array.splice(indexItem, 1)
    },
    getCorrectParamsRns() {
      const body = {}
      if (this.jsonParam) {
        try {
          body.params = JSON.parse(this.jsonParam)
        } catch (err) {
          this.errorMsg = true
          setTimeout(() => {
            this.errorMsg = false
          }, 2000)
        }
      } else {
        for (const param of this.params) {
          if (param.array.length) {
            if (!body.params) {
              body.params = {}
            }
            body.params[param.name] = param.array
          }
        }
      }
      body.fraud_filtering = false
      return body
    },
    async findRns() {
      this.loader = true
      await fetch(`https://admin.neuralgeneration.com/api/utils/rns_results`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(this.getCorrectParamsRns())
      })
        .then((res) => {
          if (res.status !== 200) {
            this.rnsFind = false
            this.errorMsg = true
            setTimeout(() => {
              this.errorMsg = false
            }, 2000)
          }
          return res.json()
        })
        .then((data) => {
          this.rnsFoundInfo = data.processed_params
          this.rnsFind = true
          if (!data.processed_params || !data.processed_params.length) {
            this.rnsFind = false
          }
        })
      this.loader = false
    },
    clearParams() {
      for (const param of this.params) {
        param.array = []
      }
    },
    backToFind() {
      this.rnsFind = false
      this.rnsFoundInfo = []
      this.jsonParam = ''
      this.clearParams()
    }
  }
}
</script>
